__turbopack_context__.v({
  "SideCardLink": "SGol_q_SideCardLink",
  "SideCardLink__Bottom": "SGol_q_SideCardLink__Bottom",
  "SideCardLink__Bottom--WithText": "SGol_q_SideCardLink__Bottom--WithText",
  "SideCardLink__Container": "SGol_q_SideCardLink__Container",
  "SideCardLink__LinkText": "SGol_q_SideCardLink__LinkText",
  "SideCardLink__Text": "SGol_q_SideCardLink__Text",
  "SideCardLink__Title": "SGol_q_SideCardLink__Title",
});
